import React, { useState } from 'react';
import { jwtDecode } from 'jwt-decode';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CryptoJS from 'crypto-js';
import BASE_URL from '../../config/config';


const EditarPerfil = () => {
  const token = localStorage.getItem('AuthToken');
  const tokenInfo = token ? jwtDecode(token) : {};
  const navigate = useNavigate();

  const [showPass, setShowPass] = useState(false);
  const [nombre, setNombre] = useState(tokenInfo.nombre || '');
  const [apellidos, setApellidos] = useState(tokenInfo.apellidos || '');
  const [email, setEmail] = useState(tokenInfo.email || '');
  const [telefono, setTelefono] = useState(tokenInfo.telefono || '');
  const [contrasena, setContrasena] = useState('');
  const [webs_del_cliente, setWebs_del_cliente] = useState(tokenInfo.webs_del_cliente || '');

  const encryptPassword = password => CryptoJS.MD5(password).toString();

  const handleLogout = () => {
    localStorage.removeItem('AuthToken');
    navigate('/iniciar-sesion', { replace: true });
    window.location.reload();
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleSaveProfile = async () => {
    let encryptedPassword = contrasena ? encryptPassword(contrasena) : '';
    const updatedData = {
      nombre,
      apellidos,
      email,
      telefono,
      ...(contrasena && { contrasena: encryptedPassword }),
      webs_del_cliente,
    };
    try {
      const response = await axios.put(
        `${BASE_URL}/usuario/update/${tokenInfo.usuario}`,
        updatedData,
        { headers: { Authorization: token } }
      );
      if (response.status === 200) {
        toast.success('Perfil actualizado con éxito.');
        handleLogout();
      } else {
        toast.error('Hubo un problema al actualizar el perfil.');
      }
    } catch (error) {
      console.error('Error al actualizar el perfil:', error);
      toast.error('Ocurrió un error al actualizar el perfil.');
    }
  };

  return (
    <main className="site-width">
        <button className="boton-volver" onClick={() => navigate('/dashboard')}>
          ← Volver
        </button>
      <div className="edit-profile-section">
        <h2>Edita tu perfil</h2>
        <div className="grid-campos-ajustes">
          <div className="campo-ajuste">
            <label htmlFor="usuario">Usuario</label>
            <p>El nombre de usuario sirve para identificar todas tus acciones en la plataforma. ¿Problemas con tu usuario? Contáctanos directamente por teléfono al <a href="tel:+34 856 901 276">856 901 276</a> marcando la extensión #2 (Desarrollo).</p>
            <input type="text" name="usuario" id="usuario" value={`@${tokenInfo.usuario}`} disabled />
          </div>
          <hr />
          <div className="texto-edit-profile">
            <h3>Información Personal</h3>
            <p>Esta información sirve para dirigirnos hacia tí y contactar contigo en caso necesario de manera correcta.</p>
          </div>
          <div className="campo-ajuste">
            <label htmlFor="nombre">Nombre</label>
            <input type="text" id="nombre" value={nombre} onChange={e => setNombre(e.target.value)} />
          </div>
          <div className="campo-ajuste">
            <label htmlFor="apellidos">Apellidos</label>
            <input type="text" id="apellidos" value={apellidos} onChange={e => setApellidos(e.target.value)} />
          </div>
          <div className="campo-ajuste">
            <label htmlFor="email">Email</label>
            <input type="email" id="email" value={email} onChange={e => setEmail(e.target.value)} />
          </div>
          <div className="campo-ajuste">
            <label htmlFor="telefono">Teléfono</label>
            <input type="text" id="telefono" value={telefono} onChange={e => setTelefono(e.target.value)} />
          </div>
          <div className="campo-ajuste">
            <label htmlFor="webs_del_cliente">Sitios en mantenimiento</label>
            <p>En caso de ser más de uno, separe sus dominios con comas.</p>
            <input type="text" id="webs_del_cliente" value={webs_del_cliente} onChange={e => setWebs_del_cliente(e.target.value)} />
          </div>
          <hr />
          <div className="texto-edit-profile">
            <h3>Seguridad</h3>
            <p>Modifica el acceso a tu cuenta.</p>
          </div>
          <div className="campo-ajuste">
            <label htmlFor="contrasena">Contraseña</label>

            <div className="input-with-toggle">
              <input
                type={showPass ? 'text' : 'password'}
                id="contrasena"
                value={contrasena}
                onChange={e => setContrasena(e.target.value)}
                autoComplete="new-password"
              />

              <button
                type="button"
                className="toggle-visibility"
                onClick={() => setShowPass(v => !v)}
                aria-label={showPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}
                aria-pressed={showPass}
                title={showPass ? 'Ocultar contraseña' : 'Mostrar contraseña'}
              >
                {showPass ? 'Ocultar' : 'Mostrar'}
              </button>
            </div>
          </div>

          <div className="adhoc-warning">
            <p>AVISO: Al guardar unos nuevos ajustes, la sesión se cerrará. (Si el campo de contraseña está vacío no se guardará).</p>
          </div>
          <button onClick={handleSaveProfile}>Guardar perfil</button>
        </div>
        <ToastContainer position="bottom-right" autoClose={3000} />
      </div>
    </main>
  );
};

export default EditarPerfil;
